
import "./HomeP.css";
import NavBarRes from "../components/resNavBar";"../components/resNavBar"
const HomeP = () => {
  return (
    <div >  
       
     
      <NavBarRes/>
      <div class="image-container">
        <img   class="imgM" src="hpbackgroundpic@2x.png" alt="Sample Image"/>
        <div class="transRecConUs">  
      
            <div className="smTit"> since 1992</div>
            <div className="homePagebigTitle">BEST ENGINEERING <br></br>AND CONTRACTING <br></br>SERVICES</div>
            <div className="smTit2">we specialize in adapting the nature with rugged terrain and converting it into flat lands suitable for human use. </div>
     
        </div>
      </div>    
     
      <div className="fl">   
        <div className="verLine"></div>
        <div className="Sercicest">Services</div>   
        <div className="verLine"></div>
      </div>
   <div className="servicesBoxesCon1">
    <div className="servRec">
      
     <img  className="servPic" src="roadconsicon.svg"/>
      <div className="servicesTex">Road<br></br> Construction</div>
    </div>
    <div className="servRec">
      
     <img  className="servPic" src="agriicon.svg"/>
     <div className="servicesTex">Land<br></br>Reclamation</div>
     
    </div>
    <div className="servRec">
      
     <img  className="servPic" src="gradingleveingcon@2x.png"/>
       <div className="servicesTex">Grading<br></br>& Leveling</div>
    </div>
  
  
 
    <div className="servRec">
     <img  className="servPic" src="infrastructureicon@2x.png"/>
     <div className="servicesTex">Infrastructure<br></br>Construction</div>
    </div>
    <div className="servRec">
      
     <img  className="servPic" src="canalsexcicon@2x.png"/>
     <div className="servicesTex">Canals<br></br>Excavation</div>
    </div>
    <div className="servRec">
      
     <img  className="servPic" src="tunnelicon.svg"/>
     <div className="servicesTex">Tunneling</div>
    </div>
  </div>
    {/*wid1*/} 
    <div className="wid1Container">
       <div className="wid1">
          <div className="wid1T">30+<br></br>EXPERIENCE</div>

          <div className="wid1T">25+<br></br>PROJECTS</div>
          <div className="wid1T">50+<br></br>EMPLOYEES</div>
       </div>
    </div>

    {/*OurMissCont*/}
    <div className="container">

     {/*leftSide*/}
      <div className="left-side">      
          <div >              
            <div className="Miss">OUR<br></br>MISSION</div>           
              <div className="leftSideCh">
                <img  className="misPic" src="missionwhitehp@2x.png"/>
                <div className="misTit"> 
                    MISSION
                </div>
              </div>
              <div className="misText">We strive to make a positive impact by using our expertise in engineering and contracting to deliver innovative solutions. Our commitment to excellence drives us to provide high-quality services that empower progress and benefit our clients and communities.</div>
      
              <div className="leftSideCh">
                  <img  className="misPic" src="visionwhitehp@2x.png"/>
                  <div className="misTit">VISION</div>
              </div>
              <div className="misText">Creating a Better Tomorrow by Building and Innovating, for Stronger Communities and a Brighter Future.</div>
          </div> 
      </div>

      {/*rightSide*/}
      <div className="right-side" >
         <img  class="" src="missionpichp@2x.png" />
         <div className="trans"></div>
       </div> 
      
    </div>

   {/*featuredProjGrid*/}

      <div className="fl">   
        <div className="verLine"></div>
        <div className="featPrTit">Featured Projects</div>   
        <div className="verLine"></div>
      </div>
    
    <div className="photo-grid">
      <img src="elecstatpic1hp@2x.png"></img>
      <img src="elecstationpic2@2x.png"></img>
      <img src="militentitypic1hp@2x.png"></img>
      <img src="militentitypic2hp@2x.png"></img>
      
      <img src="newgizapic1hp@2x.png"></img>
      <img src="newgizapic2hp@2x.png"></img>
      <img src="greenrivhp@2x.png"></img>
      <img src="r5buildingshp@2x.png"></img>

      <img src="operapic1hp@2x.png"></img>
      <img src="operapic2hp@2x.png"></img>
      <img src="remayapichp@2x.png"></img>
      <img src="swanlakepichp@2x.png"></img>

      <img src="highspeedrailpic1hp@2x.png"></img>
      <img src="highspeedrailpic2hp@2x.png"></img>
      <img src="palhillspichp@2x.png"></img>
      <img src="portosokhnahp@2x.png"></img>
    </div>

   {/*clientsSection*/}

    <div className="fl">   
        <div className="verLine"></div>
        <div className="Sercicest">Clients</div>   
        <div className="verLine"></div>
    </div >

    <div className="logosGrid">
    <img   alt=""  className="hay2aLogo" src="hay2eteltorlogo@2x.png" />
    <img   alt=""  className="hay2aLogo" src="orascomlogo@2x.png" />
    <img   alt="" className="hay2aLogo" src="hassanalllogo@2x.png" />
    <img   alt="" className="hay2aLogo"  src="arabconlogo@2x.png" />

    <img   alt=""  className="hay2aLogo" src="newgizalogo@2x.png" />
    <img   alt=""  className="hay2aLogo" src="kobelogo@2x.png" />
    <img   alt=""  className="hay2aLogo" src="marasemlogo@2x.png" />
    <img   alt=""  className="hay2aLogo" src="siaclogo@2x.png" />

    <img   alt="" className="hay2aLogo" src="redconlogo@2x.png" />
    <img   alt="" className="hay2aLogo" src="sandoo2ta2meenzobatlogo@2x.png" />   
    <img   alt="" className="hay2aLogo" src="palmhillslogo@2x.png" />
    <img   alt="" className="hay2aLogo" src="dreamlandlogo@2x.png" />
    </div>  
   
      <div class="image-container">
        <img class="imgMcu" src="contactuspichp@2x.png" alt="Sample Image"/>
        <div class="transRecConUs">
        
        </div>
         <div class="conUsLayout">
           <div class="flcon">
             <div className="verLineConUs"></div>
             <div className="ConUsT">Contact Us</div>   
             <div className="verLineConUs"></div>        
           </div>

             <div class="conBig">

                <div className="conUsLeft" >
                <img src="sammanlogoinwhite-1@2x.png"/>        
               
                </div>
                 

                <div class="conUsRight">

                  <div class="conUsRightChF">
                    
                    <img className="conUsIcon" src="emaiconwhitecupg@2x.png"/>    
                       <div className="conUsSmallTextinhpFooter">info@elsammanec.com </div>   
                  </div>

                  <div class="conUsRightCh">
                    
                    <img className="conUsIcon" src="phoneiconwhitecupg@2x.png"/> 
                    <div className="conUsSmallTextinhpFooter"> +201222191447<br/>+201095602431       
                    </div>
                  </div>

                  <div class="conUsRightCh">
                    <img className="conUsIcon" src="addwhite@2x.png"/>
                    <div className="conUsSmallTextinhpFooter">21st korash st. Hassanen heikal,nasr city  </div>   
                    
                     
                  </div>
                  
                </div>  
              </div>
           
         </div> 

      </div>
   

    </div>
  );
};

export default HomeP;
